import { IconAttention, IconTimelineAlt, IconTrip } from '@flixbus/honeycomb-icons-react';

import { CREATE_BREAKDOWN_FLOW_TEXT } from '../texts';

const LABELS = CREATE_BREAKDOWN_FLOW_TEXT.summary.rowLabels;

/**
 * @typedef {import('./summarySectionsRegistry').SummaryRow} SummaryRow
 */

const formatStation = (stationDetails) => {
	if (!stationDetails?.code) return '';
	if (!stationDetails.name) return stationDetails.code;
	return `${stationDetails.code} (${stationDetails.name})`;
};

/**
 * Build the row list for the Summary "Deadhead info" accordion.
 *
 * @param {object} data Flow-modal draft data — expects `data.deadhead`.
 * @returns {SummaryRow[]}
 */
export const deriveDeadheadInfoRows = (data) => {
	const dh = data?.deadhead;
	if (!dh) return [];

	const from = formatStation(dh.departure?.stationDetails);
	const to = formatStation(dh.arrival?.stationDetails);

	return [
		{
			label: LABELS.route,
			value: `${from} → ${to}`,
			icon: IconTrip,
		},
		{
			label: LABELS.schedule,
			value: dh.rideNumber ?? '',
			icon: IconTimelineAlt,
		},
		{
			label: LABELS.type,
			value: dh.type ?? '',
			icon: IconAttention,
		},
	];
};
